import { JsFormError } from '../../errors/jsFormError';
// @ts-ignore
import * as errorToolTip from '../errorToolTip.js';
import { Localization } from '../../localization/localization';
import { ErrorToolTip } from '../newErrorToolTip';
import { Url } from './url';
import { FingerprintjsWrapper } from './fingerprintjs/FingerprintjsWrapper';
import { GtmSender } from '../../marketing/GtmSender';
import { SystemEvents } from '../../constants/gameEvents';
import { FormHandlers } from './formHandlers';


$(document).on('keydown', async function handleJsFormEnterKeydown(event) {
    const ENTER_KEY_CODE = 13;

    if (event.keyCode === ENTER_KEY_CODE) {
        const $form = $('form.js-form:visible');

        if ($form.length === 1) {
            await handleJsFormClick(event, $('*[type="submit"]:visible', $form));
        }
    }
});

$(document).on('click.js-form', 'form.js-form *[type="submit"]', handleJsFormClick);

const registrationEndpoints = ['registration', 'lpregistration', 'registration/', 'lpregistration/'];
async function handleJsFormClick(event: JQuery.SubmitEvent | JQuery.KeyDownEvent, $button: JQuery<HTMLElement>) {
    event.preventDefault();
    ErrorToolTip.getTooltipElement().hide();
    const $this = $button ? $button : $(this);
    const $target = $button ? $button : $(event.target);
    const beforeSend = $target.data('before-send');
    const disabled = !($target.attr('disabled') === undefined);
    const $form = $this.closest('form');
    const action = $form.attr('action');
    const actionUrl = Url.getNoLangUrl(action);
    const handler = $this.data('handler');
    const sendRequest = $this.data('send-request');
    const $progress = $('*');
    let formdata: string;
    let next;

    if (disabled !== true) {
        $target.attr('disabled', 'disabled');

        if (beforeSend !== undefined) {
            try {
                next = FormHandlers.getBeforeSendHandler(beforeSend)({
                    action: actionUrl,
                    caller: $this,
                    form: $form
                });
                next = !!next;
            } catch (error) {
                const customError = new JsFormError(`Call ${handler} beforeSend handler error: ${error.message}`);
                customError.stack = error.stack;
                console.error(customError, handler);
                window.Sentry.captureException(customError);
                $target.removeAttr('disabled');
                next = false;
            }

            if (next === false) {
                $target.removeAttr('disabled');
                return false;
            }
        }

        if (handler !== undefined) {
            $progress.addClass('cursorprogress');

            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const resultHandler = function handleJsFormResponse(response: any) {
                try {
                    if (registrationEndpoints.includes(action)) {
                        GtmSender.fireMarketing(SystemEvents.REGISTRATION);
                    }
                    FormHandlers.getAfterSendHandler(handler)({
                        action: actionUrl,
                        caller: $this,
                        form: $form,
                        response: response
                    });
                } catch (error) {
                    const customError = new JsFormError(`Call ${handler} response handler error: ${error.message}`);
                    console.error(customError, handler);
                    customError.stack = error.stack;
                    window.Sentry.captureException(customError);
                } finally {
                    $target.removeAttr('disabled');
                    $progress.removeClass('cursorprogress');
                }
            };

            const failHandler = function handleJsFormFail() {
                errorToolTip($this, false, Localization._n('common_error'));
                $target.removeAttr('disabled');
                $progress.removeClass('cursorprogress');
            };

            if (sendRequest !== undefined) {
                FormHandlers.getSendRequestHandler(sendRequest)($form)
                    .then(resultHandler)
                    .catch(failHandler);
            } else {
                formdata = $form.serialize();

                const confidenceScore = await FingerprintjsWrapper.getConfidenceScore();
                formdata = `${formdata}&confidence=${confidenceScore}`;

                $.post(actionUrl, formdata)
                    .done(resultHandler)
                    .fail(failHandler);
            }
        }
    }

    return false;
}

export function disableJsFormHandler($form: JQuery) {
    $form.removeClass('js-form');
    $form.on('submit', function handleDisabledJsForm() {
        return false;
    });
}


